// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all jobs
export const viewJob = createAsyncThunk("jobs", async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}born-to-win-api/jobs`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, "loading...");
  }
});

// List only approved jobs
export const approvedJobList = createAsyncThunk("jobs", async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}born-to-win-api/paginate-jobs`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, "loading...");
  }
});

// Add new Job
export const registerJob = createAsyncThunk(
  "jobs",
  async (jobData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}born-to-win-api/jobs`,
        jobData
      );

      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Search Job by ID
export const singleJob = createAsyncThunk("jobs", async (id, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}born-to-win-api/jobs/${id}`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, "search Job ...");
  }
});

// Update Job
export const updateJob = createAsyncThunk(
  "jobs",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}born-to-win-api/jobs/${id}`,
        formData
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  }
);

// Delete Job
export const deleteJob = createAsyncThunk("jobs", async (id, thunkAPI) => {
  const token = JSON.parse(localStorage.getItem("userInfo")) || null;
  try {
    const response = await axios.delete(
      `${BaseUrl}born-to-win-api/jobs/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return handleApiResponse(response, thunkAPI, "Delete successful!");
  } catch (e) {
    return handleApiError(e, thunkAPI);
  }
});

// Single User jobs
export const singleUserJob = createAsyncThunk("jobs", async (id, thunkAPI) => {
  try {
    const response = await axios.get(
      `${BaseUrl}born-to-win-api/users-Job/${id}`
    );
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, "search Job history...");
  }
});

// Approve Job
export const approveJob = createAsyncThunk(
  "jobs",
  async (jobData, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem("userInfo")) || null;
    try {
      const response = await axios.put(
        `${BaseUrl}born-to-win-api/jobs-approve/${jobData.id}`,
        jobData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return handleApiResponse(response, thunkAPI, "Approved successfully!");
    } catch (e) {
      return handleApiError(
        e,
        thunkAPI,
        "Please try again. Invalid credentials"
      );
    }
  }
);
